<template>
   <div style="width:87vw;height:71vh">
    <el-row >    
      <el-col :span="4" :offset="19">   
          <el-input v-model="searchText" :placeholder="$t('msg.fuzzySearch')" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
      </el-col>
      <el-col :span="1" >   
        <el-button type="warning" icon="el-icon-download" @click="exportExcel" ></el-button>  
      </el-col>
    </el-row>
    <el-row style="padding-top:0.3rem">     
      <el-col :span="24">        
        <el-table size="mini" :id="tableData.tableId" :data="tableData.data.slice((currentPage-1)*pagesize,currentPage*pagesize)" border highlight-current-row ref="filterTable" 
          :empty-text="$t('msg.noDataFound')" style="width: 100%"  :max-height="maxHeight" @sort-change="sortChange" >    
          <el-table-column  v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i" :align="v.align" sortable>                 
            <template slot-scope="scope">
              <span v-if="v.link" style="word-break: break-word;white-space: pre-wrap;">
                <el-link type="primary" @click="linkAction(scope.row, scope.$index)" >{{scope.row[v.field]}} </el-link>
              </span>
              <span v-else-if="v.checkbox && (scope.row[v.field] == null || scope.row[v.field] == '')" style="word-break: break-word;">
                <el-checkbox @change="checked=>checkAction(scope.row, scope.$index, checked)" >{{v.tooltip}}</el-checkbox>
              </span>
              <span v-else style="word-break: break-word;white-space: pre-wrap;">{{ scope.row[v.field] }} </span>
            </template>
          </el-table-column>
        </el-table>
         <div style="text-align: center;margin-top: 10px;">
          <el-pagination background layout="prev, pager, next" :total="tableData.data.length" 
            :page-size="pagesize" :current-page="currentPage"  @current-change="current_change"></el-pagination>
          </div>
      </el-col>
    </el-row>
        
  </div>
</template>

<script>

import FileSaver from 'file-saver'
//import XLSX from 'xlsx'
import XLSX from "../../utils/xlsx.js";
import CommonUtil from "../../utils/commonUtil.js";
/**
 * 傳入參數的tableData內容需包含
 * 
 * 
 */

export default {
  props: {
    tableData: {
      type: Object,
      required: true
    },
    linkAction: {
      type: Function
    },
    checkAction: {
      type: Function
    },
  },
  data() {         
    return {   
      tableId: this.tableData.tableId,
      exportName: this.tableData.exportName+'_'+CommonUtil.dateFormat(new Date()),
      searchText: '',
      currentPage: this.tableData.currentPage,
      pagesize: this.tableData.pagesize,
      initPage :1,
      maxHeight:'0'
    };
  },   
  watch: {
 
    searchText () {            
      const search = (this.searchText!=null ? this.searchText.toLowerCase() : '');
      if (search) {    
        this.currentPage = 1;  
        
        let displayCol = [];

        this.tableData.columns.forEach((item, index) => {
          if(item.field != null && item.field!= ''){
            displayCol.push(item.field);
          }
        });

        this.tableData.data  = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {           
            if(displayCol.includes(key)){
              return String(dataNews[key]).toLowerCase().indexOf(search) > -1
            }            
          })
        })
      }else{
         this.tableData.data = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            return String(dataNews[key]).toLowerCase().indexOf('') > -1
          })
        })
      }
    },
    "tableData.data"(){
       this.currentPage = 1;
    }
  },
  mounted() {   
    this.$nextTick(()=>{      
	    this.maxHeight =this.$parent.$el.offsetHeight-80
    })
  },
  methods: {   
    format (val) {
      val = ( val==null ? '' : String(val) );   
      if (val != null && val.indexOf(this.searchText) !== -1 && this.searchText !== '') {
        return val.replace(this.searchText, '<font color="red">' + this.searchText + '</font>')
      } else {
        return val
      }
    },
    current_change(currentPage){
      this.currentPage = currentPage;
    },
    exportExcel(){

      this.pagesize = this.tableData.originalTableData.length + 10;      
      this.currentPage= 1;
      this.$nextTick(function () {
          let xlsxParam = { raw: true };

          let wb = XLSX.utils.table_to_book(document.querySelector('#'+this.tableId), xlsxParam);       
          let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
          try {
              FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), this.exportName+'.xlsx')
          } catch (e) {
              if (typeof console !== 'undefined') console.log(e, wbout)
          }
          this.pagesize = this.tableData.pagesize;
          return wbout
      })

    },
    sortChange(column){     
      this.$emit('reload-data-by-sort', column.prop, column.order);
    }
  }
};
</script>

